import React from 'react';
import PropTypes from 'prop-types';

export const IconInfoSecondary = ({ className }) => (
  <svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 0.5C5.38 0.5 0 5.88 0 12.5C0 19.12 5.38 24.5 12 24.5C18.62 24.5 24 19.12 24 12.5C24 5.88 18.62 0.5 12 0.5ZM10.668 12.167C10.668 11.6147 11.1157 11.167 11.668 11.167H12.3346C12.8869 11.167 13.3346 11.6147 13.3346 12.167V18.167C13.3346 18.7193 12.8869 19.167 12.3346 19.167H11.668C11.1157 19.167 10.668 18.7193 10.668 18.167V12.167ZM11.668 7.1665C11.1157 7.1665 10.668 7.61422 10.668 8.1665V8.83317C10.668 9.38546 11.1157 9.83317 11.668 9.83317H12.3346C12.8869 9.83317 13.3346 9.38546 13.3346 8.83317V8.1665C13.3346 7.61422 12.8869 7.1665 12.3346 7.1665H11.668Z" fill="url(#paint0_linear_18449_34204)" />
  </svg>
);

IconInfoSecondary.propTypes = {
  className: PropTypes.string,
};

IconInfoSecondary.defaultProps = {
  className: '',
};
